import React from "react";
import Navbar from "../components/Navbar";
import { useThemeColors } from "../Context/Theme";
import { isMobile } from "../global/helpers";
import { Grid, Box } from "@mui/material";
import Sidebar from "./Sidebar";
import Footer from "../components/Footer";
import NotificationSidebar from "./components/NotificationSidebar";
import { useGetAPIQuery } from "../Api/api";
import { READ_ALL_NOTIFICATION } from "../Api/apiConstant";
import { getToken, getUser, getUserId } from "../LoginModule/LoginUtility";
import { CircularProgress } from "@material-ui/core";

const Notifications = () => {
  const event_id = sessionStorage.getItem("event_id");
  const userData = JSON.parse(getUser());
  const user = JSON.parse(userData);
  const userCreatedDate = new Date(user?.created_date)
  const userId = getUserId()
  const token = getToken()
  const { data, isLoading } = useGetAPIQuery({
    url: `${READ_ALL_NOTIFICATION}?user_id=${userId}&event_id=${0}`,
    token: token,
  }, { refetchOnMountOrArgChange: true });
  const finalData = data?.data?.filter((item) => new Date(item.created_date) > userCreatedDate) || []
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    fontFamily,
    logo,
  } = useThemeColors();
  const [selectedNotification, setSelectedNotification] = React.useState(null);
  const eventName = sessionStorage.getItem("eventName");
  return (
    <div
      className="overflow-hidden"
      style={{ backgroundColor: backgroundColor }}
    >
      <Navbar />

      <Grid
        container
        spacing={4}
        height={"70vh"}
        style={{ margin: isMobile() ? "2% 0" : "2% 4%", marginTop: "8%" }}
      >
        {isMobile() ? (
          <Sidebar />
        ) : (
          <Grid item xs={12} sm={10} md={2} className="">
            <Sidebar />
          </Grid>
        )}
        <Grid
          container
          spacing={1}
          justifyContent={"space-between"}
          item
          height={"100%"}
          xs={12}
          sm={10}
          md={9}
        >
          <Grid item xs={12} sx={{ height: "100%" }}>
            {isLoading ? (
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <CircularProgress color="secondary" />
              </Grid>
            ) : !data || data?.status === false || finalData.length === 0 ? (
              <Box
                sx={{
                  width: "100%",
                  height: "90%",
                  maxHeight: "100%",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  maxWidth: "100%",
                  backgroundColor: "white",
                  borderRadius: "21px",
                  paddingBottom: "20px",
                  paddingTop: "20px",
                  boxShadow: "0px 4px 19px 0px #D6D6D640",
                  "@media (max-width: 600px)": {
                    maxWidth: "100%",
                    padding: "10px",
                    fontFamily: fontFamily || "poppins",
                  },
                }}
              >
                <p className="text-center mt-5" style={{
                  color: "red",
                  fontWeight: "600",
                  fontSize: "2rem",
                  fontFamily: fontFamily || "Poppins"
                }}>
                  No Notification found
                </p>
              </Box>
            ) : (
              <NotificationSidebar
                setSelectedNotification={setSelectedNotification}
                selectedNotification={selectedNotification}
                data={finalData}
                eventName={eventName}
                event_id={event_id}
                isLoading={isLoading}
              />
            )}
          </Grid>
        </Grid>

      </Grid>
      <Footer />
    </div >
  );
};

export default Notifications;
